import React, { useRef } from "react";
import "./ParentTestimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useDarkMode } from '../../contexts/DarkModeContext';

function ParentTestimonial() {
    const { isDarkMode } = useDarkMode();
    const swiperRef = useRef(null);
    const testimonials = [
        {
            name: "أحمد محمد علي",
            rating: "5.00",
            comment:
                "منصة علمي غيرت تجربة تعلم ابني بالكامل. المعلمون ممتازون والمنهج سهل الفهم.",
            image: "https://randomuser.me/api/portraits/men/32.jpg",
        },
        {
            name: "سارة أحمد محمود",
            rating: "4.95",
            comment:
                "أشكر علمي على الجهد المبذول. ابنتي تحب الدراسة الآن أكثر من أي وقت مضى.",
            image: "https://randomuser.me/api/portraits/women/44.jpg",
        },
        {
            name: "محمد عبد الرحمن",
            rating: "5.00",
            comment:
                "أفضل منصة تعليمية عربية. المحتوى غني والشرح واضح ومفصل.",
            image: "https://randomuser.me/api/portraits/men/67.jpg",
        },
        {
            name: "فاطمة حسن سعيد",
            rating: "4.90",
            comment:
                "تجربة رائعة مع علمي. المعلمون متعاونون والمنصة سهلة الاستخدام.",
            image: "https://randomuser.me/api/portraits/women/23.jpg",
        },
        {
            name: "علي محمد كمال",
            rating: "5.00",
            comment:
                "علمي ساعد ابني في تحسين مستواه الدراسي بشكل ملحوظ. أنصح بها بشدة.",
            image: "https://randomuser.me/api/portraits/men/89.jpg",
        },
        {
            name: "نورا أحمد فتحي",
            rating: "4.85",
            comment:
                "منصة ممتازة للتعلم عن بعد. المحتوى منظم والشرح مبسط للطلاب.",
            image: "https://randomuser.me/api/portraits/women/56.jpg",
        },
        {
            name: "يوسف محمود حسن",
            rating: "5.00",
            comment:
                "علمي جعل التعليم ممتعاً وسهلاً. ابني يحب الدراسة الآن أكثر من اللعب.",
            image: "https://randomuser.me/api/portraits/men/78.jpg",
        },
        {
            name: "ليلى عبد الله",
            rating: "4.95",
            comment:
                "تجربة تعليمية فريدة من نوعها. المعلمون محترفون والمحتوى عالي الجودة.",
            image: "https://randomuser.me/api/portraits/women/34.jpg",
        },
    ];

    return (
        <section className={`testimonial-section ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
            <div className="testimonial-header">
                <p className="sub-title">تقييمات طلاب علمي</p>
                <h2 className="main-title">ما قاله الطلاب وأولياء الامور</h2>
            </div>
            
            {/* Custom Navigation Buttons */}
            <div className="custom-navigation">
                <button 
                    className="nav-btn prev-btn" 
                    onClick={() => {
                        if (swiperRef.current) {
                            swiperRef.current.slidePrev();
                        }
                    }}
                >
                    <FaChevronRight />
                </button>
                <button 
                    className="nav-btn next-btn" 
                    onClick={() => {
                        if (swiperRef.current) {
                            swiperRef.current.slideNext();
                        }
                    }}
                >
                    <FaChevronLeft />
                </button>
            </div>

            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                navigation={false}
                pagination={{ clickable: true }}
                autoplay={{ delay: 3000 }}
                spaceBetween={30}
                slidesPerView={1}
                breakpoints={{
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                }}
                dir="rtl"
                className="testimonial-swiper"
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
            >
                {testimonials.map((item, idx) => (
                    <SwiperSlide key={idx}>
                        <div className="testimonial-card">
                            <div className="image-wrapper">
                                <div className="rhombus"></div>
                                <img src={item.image} alt={item.name} />
                                <div className="circle-rating">{item.rating}</div>
                            </div>

                            <h3>{item.name}</h3>
                            <p className="comment">{item.comment}</p>
                            <div className="stars">
                                {[...Array(5)].map((_, i) => (
                                    <FaStar key={i} color="#f5a623" />
                                ))}
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}

export default ParentTestimonial;
